/* eslint-disable */
import type { DateTime } from "../../common/time.pb";

export interface ClientInfo {
  user_agent?: string;
  device_uuid?: string;
  /** The date, time and timezone of the client. */
  timestamp?: DateTime;
  /** The preferred format for formatting dates on this client. Example: "M/d/yy" */
  date_format?: string;
  /** The preferred format for formatting times on this client. Example: "h:mm a" */
  time_format?: string;
  ip_address?: string;
  /** The device name extracted from X-Device-Name. Useful to detect recycled phone numbers. */
  device_name?: string;
  /** The navigation paradigm (traditional/tab-bar) of the client. */
  navigation_paradigm?: ClientInfoNavigationParadigm;
  /** The languages that the device accepts, extracted from the Accept-Language header. See https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-Language for the format. */
  accept_language?: string;
  /**
   * Option for flows to send extra information about the original flow. This information is used
   * when switching from a FlowSpec flow to a Plasma flow. This integer should represent the value
   * of the ClientScenario that it represents.
   */
  client_scenario?: number;
  /** Device installation id (for iOS). Useful checking for device denylisting */
  device_installation_id?: string;
  /** DRM id (for android). Useful checking for device denylisting */
  drm_id?: string;
}

export enum ClientInfoNavigationParadigm {
  TRADITIONAL = "TRADITIONAL",
  TABBAR = "TABBAR",
}
